import { render, staticRenderFns } from "./AlbumNoteZone.vue?vue&type=template&id=36f57a4f&scoped=true&"
import script from "./AlbumNoteZone.vue?vue&type=script&lang=js&"
export * from "./AlbumNoteZone.vue?vue&type=script&lang=js&"
import style0 from "./AlbumNoteZone.vue?vue&type=style&index=0&id=36f57a4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f57a4f",
  null
  
)

export default component.exports